module.exports = __webpack_public_path__ + "img/first.c8cc2277.jpeg";